import { Store } from '../store.model';
import { HeaderState } from './header.model';

class HeaderSelectors {
  static state = (store: Store): HeaderState => store.header;
}

export default HeaderSelectors;
